import CountryCode from "@/components/countryCode/countryCode.vue";
import LoginPasswordType from "@/views/Login/login-password-type.vue";
import Agreenment from "@/components/Agreenment/agreenment.vue";
import { mobileVerificationCode } from "@/service/user";
export default {
  name: "login-main-mobile",
  components: {
    CountryCode,
    LoginPasswordType,
    Agreenment
  },
  props: {
    login: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      passwordType: {
        type: "password",
        // 验证方式
        password: "",
        // 密码
        verificationCode: "" // 验证码
      }
    };
  },
  methods: {
    onChange(val) {
      this.passwordType = {
        ...this.passwordType,
        ...val
      };
    },
    handleContinue() {
      if (this.passwordType.type === "password") {
        this.$refs.countryCode.validate(valid => {
          if (valid) {
            this.handleContinuePassword();
          }
        });
      } else {
        this.handleContinueCode();
      }
    },
    /**
     * 验证码验证成功，发送验证码
     */
    async handleSuccessVerify(value, startResentTimeFn) {
      const res = await mobileVerificationCode(this.login.formData.mobile, value.captchaVerification, "LOGIN", this.login.formData.mobileAreaCode);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("hu974i5", "短信已发送"));
        // 验证码发送成功，开始倒计时
        startResentTimeFn();
      } else if (res.data.result === 10007) {
        //抛出异常
        this.$emit("no-mobile-email");
      }
    },
    /**
     * 密码登录
     */
    handleContinuePassword() {
      let validate = this.$refs["loginPasswordTypeMobile"].validPassword();
      validate(valid => {
        if (valid) {
          const data = {
            accountType: this.login.loginType,
            password: this.passwordType.password,
            mobile: this.login.formData.mobile,
            mobileAreaCode: this.login.formData.mobileAreaCode
          };
          this.$emit("on-continue-password", data);
        }
      });
    },
    /*
     * 验证码登录
     */
    handleContinueCode() {
      let validate = this.$refs["loginPasswordTypeMobile"].validCode();
      validate(valid => {
        if (valid) {
          this.$emit("on-continue-code", {
            mobile: this.login.formData.mobile,
            mobileAreaCode: this.login.formData.mobileAreaCode,
            verificationCode: this.passwordType.verificationCode
          });
        }
      });
    }
  }
};